import { firebase } from "@/core/modules/firebase/objects/Firebase";

export const isLoggedIn = (): boolean => {
  try {
    return firebase.auth.currentUser !== null ? true : false;
  } catch (error: unknown) {
    throw new Error("Unable to check if user is logged in");
  }
};
